import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=76d3e51b&scoped=true&"
import script from "./PersonalData.vue?vue&type=script&lang=js&"
export * from "./PersonalData.vue?vue&type=script&lang=js&"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=76d3e51b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d3e51b",
  null
  
)

export default component.exports